/*
 * WBlow signup: sent through the same function as the contact form,
 * then on to the shared thank-you page.
 */

// Read by the success page to greet the sender by name
const NAME_KEY = 'onesight-contact-name';

export function initSignup() {
    const form = document.getElementById('wbSignup');
    if (!form) return;

    const submit = form.querySelector('button[type="submit"]');
    const error = form.querySelector('.signup-error');
    const label = submit.textContent;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        let valid = true;
        form.querySelectorAll('[required]').forEach(input => {
            const ok = input.type === 'email'
                ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim())
                : !!input.value.trim();
            input.classList.toggle('is-invalid', !ok);
            if (!ok) valid = false;
        });
        if (!valid) return;

        const value = name => form.elements[name].value.trim();
        const payload = {
            type: 'contact',
            name: value('name'),
            mail: value('email'),
            company: value('company'),
            companySize: value('size'),
            subject: 'WBlow signup',
            body: `WBlow signup for ${value('company')} (${value('size')} employees).`,
            page: document.title,
        };

        error.classList.remove('is-visible');
        submit.disabled = true;
        submit.textContent = 'Sending…';

        try {
            const res = await fetch('/.netlify/functions/submit', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.message || 'Unknown error');

            try {
                sessionStorage.setItem(NAME_KEY, payload.name.split(/\s+/)[0]);
            } catch (err) {
                // Storage blocked: the success page falls back to a generic greeting
            }
            window.location.assign('/contact-success/');
        } catch (err) {
            console.error('[wblow signup]', err);
            error.classList.add('is-visible');
            submit.disabled = false;
            submit.textContent = label;
        }
    });

    form.addEventListener('input', (e) => {
        if (e.target.classList.contains('is-invalid') && e.target.value.trim()) {
            e.target.classList.remove('is-invalid');
        }
    });
}
